import React from 'react';
import { motion } from 'framer-motion';
import { pilot, pilotFacts, snak3Images } from '../../../data/snak3';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PilotScreen() {
  return <div className="flex flex-1 flex-col" data-id="element-775" data-mp="32nj1rzkelvwc">
      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative -mx-6 -mt-3" data-id="element-776" data-mp="32oklstjedsq7">
        <img src={snak3Images.clinic.src} alt={snak3Images.clinic.alt} draggable={false} className="h-[170px] w-full select-none object-cover" data-id="element-777" data-mp="2a0orfvhawcwl" />
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="absolute bottom-0 left-0 flex items-end gap-3 bg-ozGreen px-4 py-2.5" data-id="element-778" data-mp="2jwrvx7zmknmp">
          <span className="font-display text-[34px] font-bold leading-none tabular-nums text-ozNavy" data-id="element-779" data-mp="38e91759pz5d">
            50
          </span>
          <span className="pb-1 text-[9px] font-semibold uppercase leading-tight tracking-micro text-ozNavy" data-id="element-780" data-mp="3cvdzzedljvxv">
            scans
            <br data-id="element-781" data-mp="37vjfbskf02l9" />8 weeks
          </span>
        </motion.div>
      </motion.figure>

      <motion.h2 initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.06,
      ease: EASE
    }} className="mt-5 font-display text-[25px] font-semibold leading-[1.06] tracking-tight text-paper" data-id="element-782" data-mp="32wpxxp20brft">
        {pilot.headline}
      </motion.h2>

      <p className="mt-3 text-[12.5px] leading-relaxed text-paper/70" data-id="element-783" data-mp="2p5bczcojhg64">{pilot.lead}</p>

      <dl className="mt-4 flex flex-col gap-1" data-id="element-784" data-mp="2k8bafbqwevjr">
        {pilotFacts.map((fact, i) => <motion.div key={fact.label} initial={{
        opacity: 0,
        x: -6
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.22,
        delay: 0.1 + i * 0.05,
        ease: EASE
      }} className="flex items-baseline gap-3 rounded-lg bg-paper/[0.06] px-3.5 py-2" data-id="element-785" data-mp="2fartu56qa6on" data-mpi={i}>
            <dt className="w-[58px] shrink-0 text-[8.5px] font-semibold uppercase tracking-micro text-ozGreen" data-id="element-786" data-mp="1wn0uplendffr">
              {fact.label}
            </dt>
            <dd className="text-[12px] font-medium leading-snug text-paper" data-id="element-787" data-mp="1mnicb9edy1pt">{fact.value}</dd>
          </motion.div>)}
      </dl>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.4,
      ease: EASE
    }} className="mt-auto pt-5 font-display text-[19px] font-semibold leading-snug text-paper" data-id="element-788" data-mp="1rnny48xz4tzz">
        {pilot.takeaway}
      </motion.p>
    </div>;
}